/* @flow */

import * as React from 'react';
import './rating.module.css';

type Props = {
    /** Whole numbers only, for now */
    score: number,
    /** Used in the title attribute, along with the score */
    title: string,
};

Rating.defaultProps = {
    title: 'Rating',
};

/**
 * Provides a read-only display of a score on a five-star scale.
 */
export function Rating({score, title}: Props) {
    const fill1 = score > 0 ? 'filled' : 'empty';
    const fill2 = score > 1 ? 'filled' : 'empty';
    const fill3 = score > 2 ? 'filled' : 'empty';
    const fill4 = score > 3 ? 'filled' : 'empty';
    const fill5 = score > 4 ? 'filled' : 'empty';

    return (
        <div className='flex' styleName='rating-container' title={`${title}: ${score} out of 5`}>
            <i data-fill={fill1} />
            <i data-fill={fill2} />
            <i data-fill={fill3} />
            <i data-fill={fill4} />
            <i data-fill={fill5} />
        </div>
    );
}
